import { yupResolver } from "@hookform/resolvers/yup";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { DialogWrapper } from "components/shared/dialog";
import { Input } from "components/shared/input";
import { FC, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
// import AddIcon from '@material-ui/icons/Add';
import { postContactForm } from "adapters";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  ContactFormField,
  GetUrlBuilderData,
  SetUrlBuilderData,
} from "store/url-builder";
import { EditFieldDialog } from "./edit-field-dialog";

const schema = yup.object().shape({
  contactMail: yup.string().email().required().label("Email"),
});

interface FormValues {
  contactMail: string;
}

const reorder = (
  list: ContactFormField[],
  startIndex: number,
  endIndex: number
): ContactFormField[] => {
  const result = list;
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export interface ContactMeDialogProps {
  isOpen: boolean;
  onClose(): void;
  builderType: string;
}

export const ContactMeDialog: FC<ContactMeDialogProps> = ({
  isOpen,
  onClose,
  builderType,
}) => {
  const dispatch = useDispatch();
  const builderData = useSelector(GetUrlBuilderData);
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState<ContactFormField[]>(
    builderData.contactForm.fields
  );
  const [fieldToEdit, setFieldToEdit] = useState<ContactFormField | null>();
  const { cardId }: { cardId: string } = useParams();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: builderData.contactForm,
  });

  const submit = ({ contactMail }: FormValues) => {
    postContactForm(cardId, builderType, {
      contactMail,
      fields: fields,
    })
      .then(({ data }) => {
        if (!data.success) return;
        dispatch(SetUrlBuilderData(data.data));
        onClose();
      })
      .finally(() => setLoading(false));
    setLoading(true);
  };

  const openEditFieldDialog = (field: ContactFormField) =>
    setFieldToEdit(field);

  //  TODO: HIDE FOR NOW
  //  const addNewField = () => {
  //   const nextField = fields.filter((field) => field.fieldName.includes('Custom Field')).length + 1;

  //   const field: ContactFormField = {
  //    fieldName: 'Custom Field ' + nextField,
  //    fieldType: 'Text',
  //    isRequired: false,
  //    editable: true,
  //   };

  //   setFields([...fields, field]);
  //  };

  const updateField = (field: ContactFormField) => {
    const updatedFields = fields.map((f) => (fieldToEdit === f ? field : f));
    setFieldToEdit(null);
    setFields(updatedFields);
  };

  const deleteField = () => {
    const updatedFields = fields.filter((f) => fieldToEdit !== f);
    setFieldToEdit(null);
    setFields(updatedFields);
  };

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) return;
    const items = reorder(
      fields,
      result.source.index,
      result.destination.index
    );
    setFields(items);
  };

  return (
    <DialogWrapper
      open={isOpen}
      onClose={(event, reason) => {
        if (reason && reason === "backdropClick") return false;
        else onClose();
      }}
      title="Contact Me"
      loading={loading}
      onSubmit={handleSubmit(submit)}
      onDelete={deleteField}
    >
      <Grid item xs={12} className="mb-3">
        <Controller<FormValues>
          control={control}
          name="contactMail"
          render={({ field: { onChange, value } }) => (
            <Input
              label="I want to receive emails on this address"
              onChange={onChange}
              value={value}
              error={!!errors.contactMail}
              helperText={errors.contactMail?.message}
              fullWidth
              disabled={loading}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography color="textPrimary" variant="h6">
          Fields
        </Typography>
      </Grid>
      <Grid item xs={12} className="mb-4">
        <DragDropContext onDragEnd={onDragEnd}>
          {/* TODO: Fix drag&drop container height on drag */}
          <TableContainer style={{ overflow: "hidden" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="left">Type</TableCell>
                  <TableCell align="center">Required</TableCell>
                  {/* <TableCell></TableCell> */}
                </TableRow>
              </TableHead>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <TableBody
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {fields.map((field, idx) => (
                      <Draggable
                        key={field.fieldName}
                        draggableId={field.fieldName}
                        index={idx}
                      >
                        {(provided) => (
                          <TableRow
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <TableCell>
                              <DragHandleIcon />
                            </TableCell>
                            <TableCell align="left">
                              {field.fieldName}
                            </TableCell>
                            <TableCell align="left">
                              {field.fieldType}
                            </TableCell>
                            <TableCell align="center">
                              {field.isRequired && (
                                <CheckIcon fontSize="small" />
                              )}
                            </TableCell>
                            {/* <TableCell align="left">
                              <Button
                                onClick={() => openEditFieldDialog(field)}
                                variant="text"
                                color="primary"
                                disabled={!field.editable}
                              >
                                Edit
                              </Button>
                            </TableCell> */}
                          </TableRow>
                        )}
                      </Draggable>
                    ))}
                  </TableBody>
                )}
              </Droppable>
            </Table>
          </TableContainer>
        </DragDropContext>
      </Grid>
      <Grid justifyContent="center" item container xs={12}>
        {/* TODO: HIDE FOR NOW */}
        {/* <Button variant='text' onClick={addNewField}>
     <AddIcon />
     Add New Field
    </Button> */}
      </Grid>
      <EditFieldDialog
        onDelete={deleteField}
        open={!!fieldToEdit}
        closeDialog={() => setFieldToEdit(null)}
        field={fieldToEdit as ContactFormField}
        onSubmit={updateField}
      />
    </DialogWrapper>
  );
};
